var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-header", style: { "box-shadow": _vm.boxShadow } },
    [
      _c("div", { staticClass: "chat-header-title flex items-center" }, [
        _c("div", [
          !_vm.isShowingOpenChat
            ? _c(
                "button",
                {
                  staticClass: "button button-nothing button-pressed",
                  attrs: {
                    id: "restartButton",
                    type: "button",
                    "aria-label": _vm.$t("chatbot.restart"),
                  },
                  on: { click: _vm.onRestart },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "chat-header-restart-button-svg",
                      attrs: {
                        viewBox: "0 0 20 20",
                        width: "12",
                        fill: "currentColor",
                        stroke: "currentColor",
                        "aria-labelledby": "restartButton",
                      },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href": "#icon-repeat",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex-center" },
          [
            _c("customer-avatar", { staticClass: "is-big" }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "chat-header-customer-name",
                style: { "font-family": _vm.fontFamily },
              },
              [_vm._v(_vm._s(_vm.headerTitle))]
            ),
            _vm._v(" "),
            _vm.logoUrl
              ? _c("img", {
                  staticClass: "chat-header-logo",
                  attrs: { src: _vm.logoUrl, alt: "" },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _vm.showCloseButton
            ? _c(
                "button",
                {
                  staticClass: "button button-nothing close-button",
                  attrs: {
                    id: "closeButton",
                    type: "button",
                    "aria-label": _vm.$t("chatbot.close"),
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "chat-header-close-button-svg",
                      attrs: {
                        viewBox: "0 0 20 20",
                        width: "12",
                        fill: "currentColor",
                        stroke: "currentColor",
                        "aria-labelledby": "closeButton",
                      },
                    },
                    [
                      _c("use", {
                        attrs: {
                          "xlink:href": "#icon-close",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm.headerDescription && !_vm.isShowingOpenChat
        ? _c("div", { staticClass: "chat-header-description flex-center" }, [
            _c("div", { staticClass: "chat-header-description__content" }, [
              _vm._v(_vm._s(_vm.headerDescription)),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }